var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4589 22.9178C5.14018 22.9178 0 17.7776 0 11.4589C0 5.14018 5.14018 0 11.4589 0C11.8482 0 12.1642 0.315971 12.1642 0.705293C12.1642 1.09461 11.8482 1.41059 11.4589 1.41059C5.91811 1.41059 1.41059 5.91811 1.41059 11.4589C1.41059 16.9997 5.91811 21.5072 11.4589 21.5072C11.8482 21.5072 12.1642 21.8232 12.1642 22.2125C12.1642 22.6018 11.8482 22.9178 11.4589 22.9178Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7955 10.98L16.6075 7.84861C16.3341 7.58074 15.8915 7.58074 15.6188 7.84861C15.3454 8.11718 15.3454 8.55197 15.6188 8.81984L17.6131 10.7788H8.66606C8.28007 10.7788 7.9668 11.0865 7.9668 11.4657C7.9668 11.8448 8.28007 12.1525 8.66606 12.1525H17.6131L15.6188 14.1115C15.3454 14.38 15.3454 14.8148 15.6188 15.0827C15.7552 15.2166 15.9342 15.2839 16.1132 15.2839C16.2922 15.2839 16.4712 15.2166 16.6075 15.0827L19.7955 11.9513C19.8465 11.9011 19.8885 11.8448 19.9199 11.785C19.9731 11.6855 19.9997 11.5756 19.9997 11.4657C20.0004 11.2898 19.9318 11.114 19.7955 10.98Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.d8c6003bcce1cf3c9f0d371ebd6b81e7.svg";
export { ForwardRef as ReactComponent };